"use strict";
/**
 * @fileOverview Default animation configuration for elements
 */
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("@antv/util");
var action_1 = require("./action");
var defaultAnimationCfg = {
    appear: {
        duration: 450,
        easing: 'easeQuadOut',
    },
    update: {
        duration: 450,
        easing: 'easeQuadInOut',
    },
    enter: {
        duration: 400,
        easing: 'easeQuadInOut',
        delay: 100,
    },
    leave: {
        duration: 350,
        easing: 'easeQuadIn',
    },
};
var Animate = {
    line: {
        appear: function () {
            return action_1.default.appear.groupWaveIn;
        },
        enter: function () {
            return action_1.default.enter.clipIn;
        },
        leave: function () {
            return action_1.default.leave.lineWidthOut;
        },
    },
    path: {
        appear: function () {
            return action_1.default.appear.groupWaveIn;
        },
        enter: function () {
            return action_1.default.enter.clipIn;
        },
        leave: function () {
            return action_1.default.leave.lineWidthOut;
        },
    },
    area: {
        appear: function () {
            return action_1.default.appear.groupWaveIn;
        },
        enter: function () {
            return action_1.default.enter.fadeIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        cfg: {
            appear: {
                duration: 500,
                easing: 'easeQuadOut',
            },
            update: {
                duration: 450,
                easing: 'easeQuadInOut',
            },
            enter: {
                duration: 600,
                delay: 150,
                easing: 'easeQuadInOut',
            },
            leave: {
                easing: 'easeQuadOut',
                duration: 350,
            },
        },
    },
    polygon: {
        appear: function () {
            return action_1.default.appear.fadeIn;
        },
        enter: function () {
            return action_1.default.enter.zoomIn;
        },
        leave: function () {
            return action_1.default.leave.zoomOut;
        },
    },
    edge: {
        appear: function () {
            return action_1.default.appear.pathIn;
        },
        enter: function () {
            return action_1.default.enter.pathIn;
        },
        leave: function () {
            return action_1.default.leave.pathOut;
        },
    },
    interval: {
        appear: function (coord) {
            var result;
            if (coord.isPolar) { // polar coordinate
                result = action_1.default.appear.groupScaleInXY;
                if (coord.isTransposed) { // pie chart
                    result = action_1.default.appear.groupWaveIn;
                }
            }
            else {
                result = coord.isTransposed ? action_1.default.appear.groupScaleInX : action_1.default.appear.groupScaleInY;
            }
            return result;
        },
        enter: function (coord) {
            if (coord.isRect || coord.isTransposed || coord.type === 'theta') {
                return action_1.default.enter.fadeIn;
            }
            return action_1.default.enter.zoomIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        update: function (coord) {
            if (coord.type === 'theta') {
                return action_1.default.update.fanIn; // TODO: G animate 接口支持 onFrame 属性之后可以改进饼图的更新动画
            }
        },
    },
    point: {
        appear: function () {
            return action_1.default.appear.zoomIn;
        },
        enter: function () {
            return action_1.default.enter.zoomIn;
        },
        leave: function () {
            return action_1.default.leave.zoomOut;
        },
    },
    text: {
        appear: function () {
            return action_1.default.appear.zoomIn;
        },
        enter: function () {
            return action_1.default.enter.zoomIn;
        },
        leave: function () {
            return action_1.default.leave.zoomOut;
        },
    },
    kline: {
        appear: function () {
            return action_1.default.appear.groupWaveIn;
        },
        enter: function () {
            return action_1.default.enter.clipIn;
        },
        leave: function () {
            return action_1.default.leave.lineWidthOut;
        },
    },
    box: {
        appear: function () {
            return action_1.default.appear.groupWaveIn;
        },
        enter: function () {
            return action_1.default.enter.clipIn;
        },
        leave: function () {
            return action_1.default.leave.lineWidthOut;
        },
    },
    heatmap: null,
    label: {
        appear: function () {
            return action_1.default.appear.fadeIn;
        },
        enter: function () {
            return action_1.default.enter.fadeIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        cfg: {
            appear: {
                duration: 900,
            },
        },
    },
    'axis-label': {
        enter: function () {
            return action_1.default.appear.fadeIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        update: function (coord) {
            if (coord.isPolar) {
                return action_1.default.appear.fadeIn;
            }
        },
    },
    'axis-ticks': {
        enter: function () {
            return action_1.default.appear.fadeIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        update: function (coord) {
            if (coord.isPolar) {
                return action_1.default.appear.fadeIn;
            }
        },
    },
    'axis-grid': {
        enter: function () {
            return action_1.default.appear.fadeIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        update: function (coord) {
            if (coord.isPolar) {
                return action_1.default.appear.fadeIn;
            }
        },
    },
    'axis-grid-rect': {
        enter: function () {
            return action_1.default.appear.fadeIn;
        },
        leave: function () {
            return action_1.default.leave.fadeOut;
        },
        update: function () {
            return action_1.default.leave.fadeIn;
        },
    },
};
Animate.Action = action_1.default;
Animate.defaultCfg = defaultAnimationCfg;
// 获取动画
Animate.getAnimation = function (elementType, coord, animationType) {
    var elementAnimateCfg = this[elementType];
    if (elementAnimateCfg) {
        var animation = elementAnimateCfg[animationType];
        if (_.isFunction(animation)) {
            return animation(coord);
        }
    }
    return false;
};
// 获取动画配置
Animate.getAnimateCfg = function (elementType, animationType) {
    var defaultCfg = defaultAnimationCfg[animationType];
    if (this[elementType] && this[elementType].cfg && this[elementType].cfg[animationType]) {
        return _.deepMix({}, defaultCfg, this[elementType].cfg[animationType]);
    }
    return defaultCfg;
};
// 注册动画
Animate.registerAnimation = function (animationType, animationName, animationFun) {
    if (!this.Action[animationType]) {
        this.Action[animationType] = {};
    }
    this.Action[animationType][animationName] = animationFun;
};
exports.default = Animate;
//# sourceMappingURL=animate.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2/lib/animate/animate.js
// module id = 592
// module chunks = 37